<template>
  <div class="row bg-light pt-4">
    <div class="col-12">
      <div class="p-2 pb-4" v-if="!selectedClient || !selectedClient.id">
        <h4>Who's the Inbound for?</h4>
        <vue-select
          :options="clients"
          label="name"
          v-model="selectedClient" 
          placeholder="Select a client..."></vue-select>      
      </div>
      <div class="card" v-if="selectedClient && selectedClient.id">
        <div class="card-header">
          <h6 class="card-title m-0">
            New Inbound for {{ selectedClient.name }}
          </h6>
        </div>
        <table class="table">
          <tr>
            <td>PO Number</td>
            <td><input type="text" @blur="checkPoNumber" v-model="order.po_number" class="form-control" required></td>
          </tr>
          <tr>
            <td>Container Number</td>
            <td><input type="text" v-model="order.container_number" class="form-control"></td>
          </tr>
          <tr>
            <td>ETA</td>
            <td><input type="date" v-model="order.eta" class="form-control"></td>
          </tr>
        </table>
      </div>
      <div class="card mt-4" v-if="selectedClient && selectedClient.id">
        <div class="card-header">
          <h5 class="card-title m-0">Line Items</h5>
        </div>
        <table class="table w-100 bg-white table-striped">
          <thead>
            <tr>
              <th>SKU / DESCRIPTION</th>
              <th style="width: 100px;">QTY</th>
              <th style="width: 100px;">UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <vue-select :options="products" v-model="item.product"></vue-select>
              </td>
              <td>
                <input class="form-control" type="number" v-model="item.qty" style="width: 100px;">
              </td>
              <td>
                <select v-model="item.package_id" class="form-control">
                  <option value="0">EA</option>
                  <option value="1">CS</option>
                  <option value="2">PLT</option>
                </select>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><button class="btn btn-sm" @click="addLine">Add Line</button></td>
              <td>{{ totalQty }} <strong>TOTAL</strong> </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div class="p-2">
          <button class="btn btn-block btn-primary" @click="submit">Submit</button>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>

import VueSelect from 'vue-select'
import api from '@/api'


const defaultItem = {
  package_id: 1,
  qty: 1
}

export default {
  name: 'order-new',

  components: {
    VueSelect
  },
  
  data() {
    return {
      selectedClient: null,
      clients: [],
      rawProducts: [],
      items: [Object.assign({}, defaultItem)],
      order: {}
    }
  },

  watch: {
    selectedClient() {
      if (!this.selectedClient) {
        return
      }
      api.get(`/clients/${this.selectedClient.id}/products`).then(res => {
        this.rawProducts = res.data.products
      })
    }
  },

  created() {
    api.get('/clients').then((res) => {
      this.clients = res.data.clients
    })
  },

  computed: {
    products() {
      return this.rawProducts.map(p => ({ 
        id: p.id,
        sku: p.customer_sku,
        label: `${p.customer_sku} - ${p.name}`
      }))
    },

    totalQty() {
      return this.items.reduce((sum, item) => sum + parseInt(item.qty || 0), 0)
    }
  },

  methods: {
    checkPoNumber() {
      api.get(`/inbound-orders/po/${this.order.po_number}`).then(res => {
        if (res.data.order != null)  {
          alert('This PO has been used before')
        }
      })
    },

    addLine() {
      this.items.push(Object.assign({}, defaultItem))
    },

    submit() {
      this.loading = true
      const order = this.order
      order.items = this.items
      order.client_id = this.selectedClient.id
      
      api.post('/inbound-orders', { order }).then(() => {
        this.loading = false
        this.$router.push('/inbound')
      })
    }
  }
}
</script>
